module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.searchedCalendars.length > 0 && _vm.query.length > 1) ? _c('div', {
    staticClass: "search-for-calendar"
  }, [_c('div', {
    staticClass: "search-for-calendar__header"
  }, [_vm._m(0), _vm._v(" "), (_vm.calendarType === 'users') ? _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.students.users_with_same_name')))]) : _vm._e(), _vm._v(" "), (_vm.calendarType === 'students') ? _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.students.students_with_same_name')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "search-for-calendar__body"
  }, [_c('ul', {
    staticClass: "search-for-calendar__calendars"
  }, _vm._l((_vm.searchedCalendars), function(calendar) {
    return _c('li', {
      staticClass: "search-for-calendar__calendar"
    }, [_c('div', {
      staticClass: "cal-name"
    }, [_vm._v(_vm._s(calendar.name))]), _vm._v(" "), _c('div', {
      staticClass: "cal-klasses"
    }, _vm._l((_vm.getStudentKlasses(calendar)), function(klass, key) {
      return _c('span', [(key !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n            " + _vm._s(klass.name))])
    }), 0)])
  }), 0)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-for-calendar__left"
  }, [_c('div', {
    staticClass: "search-for-calendar__warning"
  }, [_c('span', {
    staticClass: "icon-warning"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f41bc9f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Students/SearchForCalendar.vue
// module id = 1751
// module chunks = 1